/**
 * @generated SignedSource<<7c089a46ce2f8d85fdaa244f1a46746a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoDurationOverlayVideo$data = {
  readonly duration: string | null | undefined;
  readonly " $fragmentType": "videoDurationOverlayVideo";
};
export type videoDurationOverlayVideo$key = {
  readonly " $data"?: videoDurationOverlayVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoDurationOverlayVideo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoDurationOverlayVideo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
};

(node as any).hash = "0f8f96d158fc35d0574364360053ac77";

export default node;
